import { IconCircleCheck } from '@tabler/icons-react'
import styled from 'styled-components'

import { omitProps } from '@subaio/components'

type Props = {
	isChecked: boolean
}

export const CheckMark = styled(IconCircleCheck)
	.withConfig({ shouldForwardProp: omitProps('isChecked') })
	.attrs({
		size: 18,
	})<Props>`
	opacity: ${({ isChecked }) => (isChecked ? 1 : 0)};
	color: ${({ theme }) => theme.color.input.menuOptionCheckMark};
	transition: opacity 135ms ease;
	flex-shrink: 0;
`
